import {
	SET_ICEPACK_INFO,
	SET_IS_ICEPACK_INFO_LOADING,
	SET_IS_ICEPACK_CREATING,
	SET_IS_ICEPACK_UPDATING,
	SET_IS_ICEPACK_DELETING,
	SET_PARTNERS,
	SET_IS_PARTNERS_LOADING,
	RESET_STATE,
} from './actions';

export const initialState = {
	icepackInfo: null,
	isIcepackInfoLoading: false,
	isIcepackCreating: false,
	isIcepackUpdating: false,
	isIcepackDeleting: false,
	partners: [],
	isPartnersLoading: false,
};

const icepackModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACK_INFO:
			return { ...state, icepackInfo: payload };
		case SET_IS_ICEPACK_INFO_LOADING:
			return { ...state, isIcepackInfoLoading: payload };
		case SET_IS_ICEPACK_CREATING:
			return { ...state, isIcepackCreating: payload };
		case SET_IS_ICEPACK_UPDATING:
			return { ...state, isIcepackUpdating: payload };
		case SET_IS_ICEPACK_DELETING:
			return { ...state, isIcepackDeleting: payload };
		case SET_PARTNERS:
			return { ...state, partners: payload };
		case SET_IS_PARTNERS_LOADING:
			return { ...state, isPartnersLoading: payload };
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepackModalReducer;
